<div class="time-picker-field">
  <label [title]="tooltip" *ngIf="!noLabel">
    {{ label | translate }}<span *ngIf="required" class="required">*</span>
  </label>

  <ng-container *ngIf="isDuration">
    <div class="time-select">
      <div class="select-row" *ngIf="longDuration">
        <select2 [cssImport]="false" [options]="selectOptions" [value]="selectedMonths" (valueChanged)="onChangedMonths($event)">
          <option *ngFor="let month of months" [value]="month.value">{{ month.description }}</option>
        </select2> <span class="select-label">{{ 'SHARED.Months' | translate }}</span>
        <select2 [cssImport]="false" [options]="selectOptions" [value]="selectedWeeks" (valueChanged)="onChangedWeeks($event)">
          <option *ngFor="let week of weeks" [value]="week.value">{{ week.description }}</option>
        </select2> <span class="select-label">{{ 'SHARED.Weeks' | translate }}</span>
        <select2 [cssImport]="false" [options]="selectOptions" [value]="selectedDays" (valueChanged)="onChangedDays($event)">
          <option *ngFor="let day of days" [value]="day.value">{{ day.description }}</option>
        </select2> <span class="select-label">{{ 'SHARED.Days' | translate }}</span>
      </div>

      <div class="hours-minutes-row">
        <div class="duration-field">
          <input type="number"
                 class="duration-input"
                 [value]="selectedHour"
                 (input)="onHourInput($event)"
                 (blur)="validateHour()"
                 min="0"
                 [max]="longDuration ? null : 23"
                 placeholder="0">
          <span class="field-label">{{ 'SHARED.Hours' | translate }}</span>
        </div>
        <div class="duration-field">
          <input type="number"
                 class="duration-input"
                 [value]="selectedMinute"
                 (input)="onMinuteInput($event)"
                 (blur)="validateMinute()"
                 min="0"
                 max="59"
                 placeholder="0">
          <span class="field-label">{{ 'SHARED.Minutes' | translate }}</span>
        </div>
      </div>
    </div>
  </ng-container>

  <input *ngIf="!isDuration" type="time" [value]="time" [min]="min" [max]="max" (change)="onChangedValue($event)" />
</div>
